const config = {
  version: "0.2.0",
  api: {
    baseURL: process.env.REACT_APP_API_URL || "http://localhost:3001/api/v1",
    timeout: 10000, // 10 seconds
  },
};

export default config;
